import type { MaybeRefOrGetter } from 'vue'

type QueryKeyArg = MaybeRefOrGetter<string | number | boolean | undefined | null | string[]>

function factory(queryName: string) {
  return (...args: QueryKeyArg[]) => {
    return [queryName, ...args]
  }
}

export const queryKeys = {
  faqList: factory('faqList'),
  newsList: factory('newsList'),
  getDeliveryAddress: factory('getDeliveryAddress'),
  getFeedbackCategories: factory('getFeedbackCategories'),
  ordersList: factory('ordersList'),
  usersRoles: factory('usersRoles'),
  usersSelectProfilesByIds: factory('usersSelectProfilesByIds'),
  usersSelectProfilesList: factory('usersSelectProfilesList'),
}
